import UnlockPassword from './UnlockPassword.vue'

export default UnlockPassword
